import React from 'react'

import { connect, DataItem, navigateTo, urlForDataItem } from 'scrivito'

interface DataItemLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  dataItem: DataItem | null | undefined
}

/**
 * Renders a real `<a href>` for a DataItem, giving the browser full native
 * link behavior: Cmd/Ctrl+click opens in a new tab, right-click context menu
 * shows "Open in new tab", etc.
 *
 * On a plain left-click (no modifier) the default is prevented and Scrivito's
 * `navigateTo` is used for SPA navigation instead.
 */
export const DataItemLink = connect(function DataItemLink({
  dataItem,
  children,
  onClick,
  ...rest
}: DataItemLinkProps) {
  if (!dataItem) return <>{children}</>

  let href: string | null = null
  try {
    href = urlForDataItem(dataItem)
  } catch {
    // urlForDataItem is not supported in all environments (e.g. in-memory tenant in tests)
  }

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    onClick?.(e)
    if (e.defaultPrevented) return
    e.stopPropagation()
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) {
      return
    }
    e.preventDefault()
    navigateTo(dataItem)
  }

  return (
    <a href={href || '#'} onClick={handleClick} {...rest}>
      {children}
    </a>
  )
})
